import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "../../../../api/api";
import "../../../../components/table.css";
import VisibilityIcon from "@mui/icons-material/Visibility";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import DownloadIcon from "@mui/icons-material/Download";
import Pagination from "../../../../components/Pagination";
import EditIcon from "@mui/icons-material/Edit";
import Breadcrumbs from "../../../../components/Breadcrumbs";
import Table from "../../../../components/table";
import usePagination from "../../../../utils/usePagination";

const ListofBL = () => {
  const [enquiries, setEnquiries] = useState([]);
  const [loading, setLoading] = useState(true);
 
 const {
   currentPage,
   itemsPerPage,
   totalPages,
   totalItems,
   currentItems,
   goToPage,
   handleItemsPerPageChange,
 } = usePagination(enquiries, 5);

 const handleDownload = async (enqId, documentName, fileName) => {
   try {
     const response = await api.get(`/download-document/bl/${enqId}?documentName=${encodeURIComponent(documentName)}`, { responseType: 'blob' });
     const blob = response.data;
     const url = window.URL.createObjectURL(blob);
     const link = document.createElement('a');
     link.href = url;
     link.download = fileName || 'BL_Draft.pdf';
     document.body.appendChild(link);
     link.click();
     document.body.removeChild(link);
     window.URL.revokeObjectURL(url);
   } catch (error) {
     console.error('Download failed:', error);
   }
 };

  useEffect(() => {
    const fetchEnquiries = async () => {
      try {
        const response = await api.get("/bl/bl-list");
        setEnquiries(
          Array.isArray(response.data.bookings) ? response.data.bookings : []
        );
      } catch (error) {
        console.error("Failed to fetch bookings:", error);
        setEnquiries([]);
      } finally {
        setLoading(false);
      }
    };

    fetchEnquiries();
  }, []);

 
  const columns = [
    { label: "Bookings No", accessor: "enq_id" },
    {
      label: "Port of Loading",
      accessor: "pol",
    },
    { label: "Port of Discharge", accessor: "pod" },
    { label: "Status", accessor: "Status" },
    {
      label: "Action",
      render: (bookings) => (
        <div className="d-flex gap-2 justify-content-center">
          <Link to={`/view-bl-draft/${bookings.enq_id}`} title="View">
            <VisibilityIcon style={{ fontSize: 20 }} />
          </Link>

          {/* {(bookings.Status_client === "BL Draft Created" ||
            bookings.Status_client === "BL Pending") && (
            <Link
              to={`/my-bookings/edit-shipping-instructions/${bookings.enq_id}`}
              title="Edit"
            >
              <EditIcon style={{ fontSize: 20 }} />
            </Link>
          )} */}

          {(bookings.Status === "BL Draft Created" || bookings.Status === "BL Accepted") && (
            <>
              {bookings.switch_bl === "Yes" ? (
                <>
                  <span
                    onClick={() => handleDownload(bookings.enq_id, 'BL Draft BL1', `BL_Draft_BL1_${bookings.enq_id}.pdf`)}
                    title="Download BL1"
                    style={{ cursor: 'pointer' }}
                  >
                    <DownloadIcon style={{ fontSize: 20 }} />
                  </span>
                  <span
                    onClick={() => handleDownload(bookings.enq_id, 'BL Draft BL2', `BL_Draft_BL2_${bookings.enq_id}.pdf`)}
                    title="Download BL2"
                    style={{ cursor: 'pointer' }}
                  >
                    <DownloadIcon style={{ fontSize: 20 }} />
                  </span>
                </>
              ) : (
                <span
                  onClick={() => handleDownload(bookings.enq_id, 'BL Draft', `BL_Draft_${bookings.enq_id}.pdf`)}
                  title="Download BL"
                  style={{ cursor: 'pointer' }}
                >
                  <DownloadIcon style={{ fontSize: 20 }} />
                </span>
              )}
            </>
          )}

          {bookings.booking_doc_status !== "Submitted" && (
            <Link
              to={`/upload-documents/${bookings.enq_id}`}
              title="Upload Document"
            >
              <UploadFileIcon style={{ fontSize: 20 }} />
            </Link>
          )}
        </div>
      ),
    },
  ];
  return (
    <>
      {loading ? (
        <p>Loading BL Draft...</p>
      ) : (
        <>
          <Breadcrumbs />
          <Table
            columns={columns}
            data={currentItems}
            loading={loading}
            emptyMessage="No BL Found"
             itemsPerPage={itemsPerPage}
            pagination={
              <Pagination
                currentPage={currentPage}
                totalPages={totalPages}
                onPageChange={goToPage}
                itemsPerPage={itemsPerPage}
                onItemsPerPageChange={handleItemsPerPageChange}
                totalItems={totalItems}
              />
            }
          />
         
        </>
      )}
    </>
  );
};
export default ListofBL;